export default class SubscriptionSettings {
  constructor() {
    this.init();
    this.createToaster();
    this.initModal();
  }

  init() {
    const settingsForm = document.querySelector(
      '.subscription-settings_form form[name="subscription_settings_form"]'
    );

    // Initialize collapsible regions
    const regionHeaders = document.querySelectorAll('.region-header');
    regionHeaders.forEach((header) => {
      header.addEventListener('click', this.handleRegionHeaderClick);
    });

    // Add change listeners to all checkboxes
    const allCheckboxes = document.querySelectorAll('input[type="checkbox"]');
    allCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => this.showToaster());
    });

    // Hide toaster when form is submitted
    if (settingsForm) {
      settingsForm.addEventListener('submit', () => this.hideToaster());
    }

    // Delete account handler - Fixed binding
    const deleteAccountBtn = document.querySelector(
      'button[name="subscription_settings_form[delete_account]"]'
    );
    if (deleteAccountBtn) {
      deleteAccountBtn.addEventListener('click', (e) =>
        this.handleDeleteAccount(e)
      );
    }
  }

  createToaster() {
    const toaster = document.createElement('div');
    toaster.className = 'toaster hidden';
    toaster.innerHTML = `
      <svg class="toaster-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM10.9562 10.5584C12.1025 9.98533 13.3931 11.0206 13.0823 12.2639L12.3733 15.0999L12.4148 15.0792C12.7852 14.894 13.2357 15.0441 13.421 15.4146C13.6062 15.7851 13.4561 16.2356 13.0856 16.4208L13.0441 16.4416C11.8979 17.0147 10.6072 15.9794 10.9181 14.7361L11.6271 11.9001L11.5856 11.9208C11.2151 12.1061 10.7646 11.9559 10.5793 11.5854C10.3941 11.2149 10.5443 10.7644 10.9148 10.5792L10.9562 10.5584ZM12 9C12.4142 9 12.75 8.66421 12.75 8.25C12.75 7.83579 12.4142 7.5 12 7.5C11.5858 7.5 11.25 7.83579 11.25 8.25C11.25 8.66421 11.5858 9 12 9Z" fill="#1D72E6"/>
      </svg>
      <p class="toaster-message">Vergeet niet je wijzigingen op te slaan</p>
    `;
    document.body.appendChild(toaster);
    this.toaster = toaster;
  }

  showToaster() {
    if (this.toaster) {
      this.toaster.classList.remove('hidden');
    }
  }

  hideToaster() {
    if (this.toaster) {
      this.toaster.classList.add('hidden');
    }
  }

  handleRegionHeaderClick(e) {
    const region = this.dataset.region;
    const content = document.querySelector(`[data-region-content="${region}"]`);
    const icon = this.querySelector('.toggle-icon');

    if (content && icon) {
      content.classList.toggle('expanded');
      icon.classList.toggle('collapsed');
    }
  }

  initModal() {
    this.modal = document.getElementById('delete-confirmation-modal');
    if (!this.modal) return;

    // Close button handler
    const closeBtn = this.modal.querySelector('.modal__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closeModal());
    }

    // Cancel button handler
    const cancelBtn = this.modal.querySelector('#modal-cancel');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', () => this.closeModal());
    }

    // Confirm button handler
    const confirmBtn = this.modal.querySelector('#modal-confirm');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', () => {
        this.confirmDelete();
      });
    }

    // Close on overlay click
    const overlay = this.modal.querySelector('.modal__overlay');
    if (overlay) {
      overlay.addEventListener('click', () => this.closeModal());
    }

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('is-active')) {
        this.closeModal();
      }
    });
  }

  handleDeleteAccount(e) {
    e.preventDefault();
    const modal = document.getElementById('delete-confirmation-modal');
    if (modal) {
      modal.classList.add('is-active');
    }
  }

  closeModal() {
    if (this.modal) {
      this.modal.classList.remove('is-active');
    }
  }

  confirmDelete() {
    const confirmBtn = this.modal.querySelector('#modal-confirm');
    if (confirmBtn) {
      // Add loading state
      confirmBtn.disabled = true;
      confirmBtn.innerHTML = `
        <div class="loader__graphic">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      `;
    }

    const deleteAccount = document.querySelector(
      'input[name="subscription_settings_form[delete_account_val]"]'
    );
    if (deleteAccount) {
      deleteAccount.value = 'true';
      // Submit the form
      deleteAccount.closest('form').submit();
    }
  }
}
